// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"73":"boss-fight","335":"development-options"}[chunkId] || chunkId) + "-" + {"1":"c6150234cb84b7b8c99c","44":"899acaab944d2c57847d","73":"ff8e177df9642cc2adb6","175":"ca093960bc2faa935fe7","335":"f4098af98ccd879743df","610":"85fae393a157ecb3dcd2"}[chunkId] + ".js";
};